import React, { useContext } from "react";
import Player from "../../../../../components/Player/Player";
import InfoPanel from "./Components/InfoPanel";
import Header from "./Components/Header";
import ResourceSeriesProvider from "../../../../../components/Player/ResourceSeries/Contexts";
import { useParams } from "react-router-dom";
import { sessionStore } from "../../../../../contexts/SessionContext";
import { LegacyLoader } from "../../../../../components/Loader/Loader";
import usePlaylistToResourceSeries from "../../usePlaylistToResourceSeries";
import playlistResourceSeriesReducer from "./playlistResourceSeriesReducer";
import PlaylistResourceSeriesSummary from "../../Student/PlaylistPlayer/Components/PlaylistResourceSeriesSummary";
import TabTitle from "../../../../../components/TabTitle/TabTitle";
import { Playlist } from "../../type";

const PlaylistPlayer = () => {
    const { playlistId } = useParams<{ playlistId: string }>();
    const {
        session: { userId },
    } = useContext(sessionStore);

    const initialResourceSeries = usePlaylistToResourceSeries(
        playlistId,
        userId
    );
    console.log("initialResourceSeries", initialResourceSeries);
    if (!initialResourceSeries) return <LegacyLoader />;

    const playlist = initialResourceSeries.resources[
        initialResourceSeries.entryLearningSetId
    ] as unknown as Playlist;

    return (
        <>
            <TabTitle title={playlist.name} />
            <ResourceSeriesProvider
                key={playlistId}
                initialResourceSeries={initialResourceSeries}
                resourceSeriesReducer={playlistResourceSeriesReducer}
            >
                <Player
                    InfoPanel={InfoPanel}
                    Header={Header}
                    ResourceSeriesSummary={PlaylistResourceSeriesSummary}
                />
            </ResourceSeriesProvider>
        </>
    );
};
export default PlaylistPlayer;
